<template>
  <div class="indicator-dots d-flex flex-grow-1 align-center justify-center" :class="{ 'post-colors': postColors }">
    <i-custom-dot
      v-for="(slide, index) in slides"
      :key="`slide-dot-${index}`"
      class="slide-dot size-3"
      :class="{
        'slide-dot--active': activeIndex === index,
        'ml-1': index
      }"
    />
  </div>
</template>

<script>
export default {
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    postColors: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.indicator-dots {
  .slide-dot {
    transition: color 0.5s ease;
    color: var(--wall-detail) !important;

    &--active {
      color: var(--wall-tint) !important;
    }
  }

  &.post-colors {
    .slide-dot {
      color: var(--post-detail-40) !important;

      &--active {
        color: var(--post-tint) !important;
      }
    }
  }
}
</style>
